module.exports = __webpack_public_path__ + "img/classify1.a9b35c5.png";